import { useEffect } from 'react'

type Props = {
  key: string
  handler: () => void
  condition: boolean
}

export const useKeyPress = ({ key, handler, condition }: Props) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === key) handler()
    }

    if (condition) window.addEventListener('keydown', onKeyDown)

    return () => window.removeEventListener('keydown', onKeyDown)
  }, [handler, condition, key])
}
